import React from 'react';
import { Link } from '@smarterservices/smarter-ui';
import { SETTINGS_LINKS } from '../constants';

interface OSSettingsLinkProps {
  /**
   * Operating system ('windows', 'mac', or other)
   */
  os?: string;
  /**
   * Device type ('camera' or 'microphone')
   */
  deviceType: 'camera' | 'microphone';
  /**
   * Optional text to display in the link
   */
  text?: string;
  /**
   * Optional class name for styling
   */
  className?: string;
}

/**
 * A link component that opens the operating system's device settings
 */
const OSSettingsLink: React.FC<OSSettingsLinkProps> = ({ os = 'windows', deviceType, text = 'Settings', className }) => {
  let settingsUri = '#';

  if (os.toLowerCase() === 'windows') {
    settingsUri = SETTINGS_LINKS[deviceType].windows;
  } else if (os.toLowerCase() === 'mac') {
    settingsUri = SETTINGS_LINKS[deviceType].mac;
  }

  return (
    <Link 
      href={settingsUri}
      aria-label={`Open Operating System ${deviceType.charAt(0).toUpperCase() + deviceType.slice(1)} Settings`}
      className={className}
    >
      {text}
    </Link>
  );
};

export default OSSettingsLink;
